<template>
  <div v-if="newsItems.length">
    <transition-group
      name="feed-transition"
      tag="div"
      class="mg-grid"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOut"
    >
      <card v-for="(item, index) in newsItems" :key="index" :post="item"></card>
    </transition-group>
    <div class="p-4 py-10 text-center antialiased" v-if="moreToLoad">
      <button
        @click="loadMoreArticles"
        class="mg-button mg-button--accent px-6 uppercase"
      >
        Load More
      </button>
    </div>
  </div>
  <div
    v-else
    class="mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center"
  >
    <div v-if="totalItemsFound == null">
      {{ feedType === "reports" ? "Loading reports..." : "Loading news..." }}
    </div>
    <div v-else>
      Nothing found.
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex";
  import Card from "@/vue-components/card";

  export default {
    name: "card-feed",
    props: ["feedType"],
    components: {
      card: Card,
    },
    computed: {
      ...mapState(["newsItems", "totalItemsFound"]),
      moreToLoad() {
        if (this.totalItemsFound === null) {
          return false;
        } else {
          return !(parseInt(this.totalItemsFound) === this.newsItems.length);
        }
      },
    },
    methods: {
      ...mapActions(["getNewsroomFeed", "getReportsFeed"]),
      loadMoreArticles() {
        // Call the appropriate feed based on feedType prop
        if (this.feedType === "reports") {
          this.getReportsFeed(true);
        } else {
          this.getNewsroomFeed(true);
        }
      },
    },
    created() {
      // Call the appropriate feed based on feedType prop
      if (this.feedType === "reports") {
        this.getReportsFeed();
      } else {
        this.getNewsroomFeed();
      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/js/vue-components/card-feed.vue